import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";
import benifity from "../images/social-site/benifity.webp";
import facebook from "../images/social-site/facebook.webp";
import instagram from "../images/social-site/instagram.webp";
import linkedin from "../images/social-site/linkedin.webp";
import socialBannerImg from "../images/social-site/social-banner.webp";
import tiktok from "../images/social-site/tiktok.webp";
import twitter from "../images/social-site/twiter.webp";
import ustazi from "../images/social-site/ustazi.webp";
import youtube from "../images/social-site/youtube.webp";

const socialSiteData = [
  {
    name: "Facebook",
    image: facebook,
    link: "https://facebook.com/afrosocial247",
  },
  {
    name: "YouTube",
    image: youtube,
    link: "https://www.youtube.com/channel/UC-sdlva6q-MZhUqwtTcr8TQ",
  },
  {
    name: "Twitter",
    image: twitter,
    link: "https://twitter.com/afrosocial247/",
  },
  {
    name: "LinkedIn",
    image: linkedin,
    link: "https://www.linkedin.com/company/afrosocial247/",
  },
  {
    name: "Instagram",
    image: instagram,
    link: "https://www.instagram.com/afrosocial247/",
  },
  {
    name: "TikTok",
    image: tiktok,
    link: "",
  },
  {
    name: "Ustaze",
    image: ustazi,
    link: "",
  },
  {
    name: "Benifity",
    image: benifity,
    link: "",
  },
];

const SocialSite = () => {
  return (
    <>
      <Helmet>
        <title>AFRO || Social Site</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground="image"
        videoURL=""
        imageURL=""
        staticImageURL={socialBannerImg}
      >
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            /Afro<span className="gilroy-bold">Social</span>247
          </h1>
        </div>
      </Header>
      <div className="container-fluid">
        <div className="me-47 ms-47 pt-7 pb-7">
          <p className="fs-18 lh-30 text-align-justify">
            We provide our customers, most of whom are leading mobile network
            operators (MNOs), with critical infrastructure that facilitates
            mobile communications coverage and connectivity to almost 600
            million people in nine countries in emerging markets. <br /> <br />
            With more than 40,000 towers in Africa, Latin America and the Middle
            East, we are among the world’s largest independent contractors for
            build and operate, the resident company in 16 of our 29 markets, and
            the market leader in 8 of them, including in Middle-East & Africa.{" "}
            <br /> <br /> Since AFRO’ inception in 2001, we have established a
            reputation as a leader in the high growth, emerging market
            communications infrastructure sector, servicing MNOs and ultimately
            the growing end-consumer market through critical infrastructure,
            which also benefits our markets' broader communities by accelerating
            access to mobile communications.
          </p>
        </div>
      </div>
      <div className="bg-american-yellow text-white pt-7 pb-7">
        <h1 className="fs-56 lh-64 gilroy-bold text-center">
          Connect with us in social media
        </h1>
        <p className="fs-20 lh-30 text-center mt-3">
          Follow us and get updates delivered to your favorite social media
          channel.
        </p>
      </div>
      <div className="container-fluid">
        <div className="me-47 ms-47 pt-7 pb-7">
          <div className="row">
            {socialSiteData.map((data, index) => (
              <div className="col-md-3 mb-5" key={index}>
                <a
                  href={data?.link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none"
                >
                  <div className="bg-white rounded-lg mb-5 review-shadow position-relative transform-up h-100">
                    <div className="d-flex justify-content-center">
                      <img
                        src={data?.image}
                        alt="user"
                        className="img-fluid rounded"
                      />
                    </div>
                    <div className="text-center mt-3 p-1">
                      <h3 className="fs-18 fw-bold text-secondary">
                        {data?.name}
                      </h3>
                    </div>
                    <div className="review-card-border"></div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SocialSite;
